import type { CSSProperties } from 'react';
import { DatasheetFieldComponentHeadingPosition } from '@common/dto/datasheet/field-component/heading-position';
import { DatasheetFieldComponentTextAlign } from '@common/dto/datasheet/field-component/text-align';

const HEADING_SIDE_GAP = 5;

type HeadingSize = { width: number; height: number };

export const getHeadingAlignmentStyle = ({
  headingPosition,
  headAlign,
  fieldWidth,
}: {
  headingPosition: DatasheetFieldComponentHeadingPosition;
  headAlign: DatasheetFieldComponentTextAlign;
  fieldWidth: number;
}): CSSProperties | undefined => {
  if (
    headingPosition !== DatasheetFieldComponentHeadingPosition.top &&
    headingPosition !== DatasheetFieldComponentHeadingPosition.bottom
  ) {
    return undefined;
  }

  const justifyContent =
    headAlign === DatasheetFieldComponentTextAlign.center
      ? 'center'
      : headAlign === DatasheetFieldComponentTextAlign.right
      ? 'flex-end'
      : 'flex-start';

  return {
    width: fieldWidth,
    left: 0,
    justifyContent,
  };
};

export const getHeadingPositionOffset = ({
  headingPosition,
  headAlign,
  headingSize,
  fieldWidth,
  fieldHeight,
}: {
  headingPosition: DatasheetFieldComponentHeadingPosition;
  headAlign: DatasheetFieldComponentTextAlign;
  headingSize: HeadingSize;
  fieldWidth: number;
  fieldHeight: number;
}): { top?: number; left?: number } | undefined => {
  const safeHeadingSize = headingSize || { width: 0, height: 0 };

  if (headingPosition === DatasheetFieldComponentHeadingPosition.top) {
    return { top: -safeHeadingSize.height, left: 0 };
  }

  if (headingPosition === DatasheetFieldComponentHeadingPosition.bottom) {
    return { top: fieldHeight, left: 0 };
  }

  if (headingPosition === DatasheetFieldComponentHeadingPosition.left) {
    return {
      top:
        headAlign === DatasheetFieldComponentTextAlign.center
          ? (fieldHeight - safeHeadingSize.height) / 2
          : 0,
      left: -safeHeadingSize.width - HEADING_SIDE_GAP,
    };
  }

  if (headingPosition === DatasheetFieldComponentHeadingPosition.right) {
    return {
      top:
        headAlign === DatasheetFieldComponentTextAlign.center
          ? (fieldHeight - safeHeadingSize.height) / 2
          : 0,
      left: fieldWidth + HEADING_SIDE_GAP,
    };
  }

  return undefined;
};
